<template>
  <div>
    <b-row>
      <b-col>
        <h5>{{item.name}}</h5>
      </b-col>
      <b-col>
        <h5>{{getPosetive.toLocaleString()}} ریال</h5>
      </b-col>
    </b-row>
    <div v-for="x in getChild" v-bind:key="x.id">
      <BalanceItem class="ml-5" v-bind:item="x" v-bind:list="list"></BalanceItem>
      <hr />
    </div>
  </div>
</template>
<script>
export default {
  name: "BalanceItem",
  props: ["item", "list"],
  components: {
    BalanceItem: this
  },
  computed: {
    getChild() {
      var id = this.item.id;
      return this.list.filter(element => {
        return element.parent_id == id;
      });
    },
    getPosetive() {
      var number = this.item.sumBed - this.item.sumBes;
      if (number < 0) return -1 * number;
      return number;
    }
  },
  methods: {}
};
</script>